// Sidebar2.js
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MENUITEMS2 } from "./menu22";
import redirectURL from '../../redirectURL';
import { getDecoder } from "../utils";
import withRouter from "./withRouter"; // Adjust the path accordingly

class Sidebar2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPath: "1",
            mainmenu: null,
            searchQuery: "",
            filteredMenu: null,
        };
    }

    componentDidMount() {
        const user = getDecoder();
        const { location } = this.props;
        const currentUrl = location.pathname;

        if (!localStorage.getItem("usermenus")) {
            const body = { role: user.role[0] };
            redirectURL.post('/getMenus', body)
                .then(res => {
                    this.setState(
                        {
                            mainmenu: res.data.menus,
                            filteredMenu: res.data.menus,
                        },
                        () => {
                            this.setActiveMenu(currentUrl);
                        }
                    );
                    localStorage.setItem('usermenus', JSON.stringify(res.data.menus));
                })
                .catch(err => console.log(err));
        } else {
            const storedMenus = JSON.parse(localStorage.getItem("usermenus"));
            this.setState(
                {
                    mainmenu: storedMenus,
                    filteredMenu: storedMenus,
                },
                () => {
                    this.setActiveMenu(currentUrl);
                }
            );
        }
    }

    componentDidUpdate(prevProps) {
        // Detect route changes and update active menu
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setActiveMenu(this.props.location.pathname);
        }
    }

    setActiveMenu = (currentUrl) => {
        const { mainmenu } = this.state;

        if (mainmenu) {
            const updatedMenu = this.findAndActivateMenu([...mainmenu], currentUrl);
            this.setState({ mainmenu: updatedMenu, filteredMenu: updatedMenu });
        }
    };

    // Recursive function to find and activate the correct menu item
    findAndActivateMenu = (menuItems, currentUrl) => {
        return menuItems.map((item) => {
            item.active = false; // Reset active state

            if (item.path === currentUrl) {
                item.active = true;
                return item;
            }

            if (item.children) {
                item.children = this.findAndActivateMenu(item.children, currentUrl);
                const isAnyChildActive = item.children.some(child => child.active);
                if (isAnyChildActive) {
                    item.active = true;
                }
            }

            return item;
        });
    };

    setNavActive = (item, shouldCloseSidebar = false) => {
        let MENUITEMS = [...this.state.mainmenu];

        MENUITEMS.forEach((menuItem) => {
            if (menuItem !== item) menuItem.active = false;

            if (menuItem.children && menuItem.children.includes(item))
                menuItem.active = true;

            if (menuItem.children) {
                menuItem.children.forEach((submenuItems) => {
                    if (submenuItems.children && submenuItems.children.includes(item))
                        menuItem.active = true;

                    if (submenuItems !== item)
                        submenuItems.active = false;

                    if (submenuItems.children && submenuItems.children.length > 0) {
                        if (submenuItems.children.includes(item)) {
                            this.onHideSidebar(); // Close sidebar when an item is clicked
                        }
                    }
                });
            }
        });

        item.active = !item.active;

        if (shouldCloseSidebar) {
            this.onHideSidebar(); // Close sidebar when nav link is clicked
        }

        this.setState({ mainmenu: MENUITEMS, filteredMenu: MENUITEMS });
    };

    // Handle search input changes
    onSearchChange = (event) => {
        const searchQuery = event.target.value.toLowerCase();
        this.setState({ searchQuery }, this.filterMenuItems);
    };

    // Filter menu items based on the search query
    filterMenuItems = () => {
        const { searchQuery, mainmenu } = this.state;

        const resetMenu = (menuItems) => {
            return menuItems.map(menuItem => {
                menuItem.active = false;
                if (menuItem.children) {
                    menuItem.children = resetMenu(menuItem.children);
                }
                return menuItem;
            });
        };

        const resetMainMenu = resetMenu(mainmenu);

        if (!searchQuery) {
            this.setState({ filteredMenu: resetMainMenu });
            return;
        }

        const filteredMenu = resetMainMenu
            .map(menuItem => {
                let newItem = { ...menuItem };

                if (menuItem.name.toLowerCase().includes(searchQuery)) {
                    return newItem;
                }

                if (menuItem.children) {
                    newItem.children = menuItem.children
                        .map(child => {
                            let newChild = { ...child };

                            if (child.name.toLowerCase().includes(searchQuery)) {
                                newChild.active = true;
                                newItem.active = true;
                                return newChild;
                            }

                            if (child.children) {
                                newChild.children = child.children.filter(subChild => {
                                    if (subChild.name.toLowerCase().includes(searchQuery)) {
                                        subChild.active = true;
                                        newChild.active = true;
                                        newItem.active = true;
                                        return subChild;
                                    }
                                    return null;
                                });
                            }

                            return newChild;
                        })
                        .filter(child => child.active);
                }

                return newItem.active ? newItem : null;
            })
            .filter(item => item !== null);

        this.setState({ filteredMenu });
    };

    clearSearchAndCloseSidebar = () => {
        this.setState({ searchQuery: "" }, () => {
            this.filterMenuItems();
            this.onHideSidebar();
        });
    };

    clearSearch = () => {
        this.setState({ searchQuery: "" }, this.filterMenuItems);
    };

    // Optional: Highlight search text in menu items
    highlightSearchText = (text) => {
        const { searchQuery } = this.state;
        if (!searchQuery) return text;
        const regex = new RegExp(`(${searchQuery})`, 'gi');
        const parts = text.split(regex);
        return parts.map((part, index) =>
            part.toLowerCase() === searchQuery.toLowerCase() ?
                <span key={index} style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>{part}</span> :
                part
        );
    };

    onCloseSidebar = () => {
        this.setState({ searchQuery: '' }, () => {
            this.filterMenuItems();
            // Optionally, hide the sidebar here if needed
        });
        document.querySelector(".page-body-wrapper").classList.add("sidebar-close");
        document.querySelector(".siconbg").classList.remove("show-m");
        document.querySelector(".siconbg").classList.add("show-n");
        document.querySelector(".sidemenu").classList.remove("l20n");
        document.querySelector(".sidemenu").classList.add("whgb");
        document.querySelector(".sidebrclose").classList.remove("show-n");
        document.querySelector(".sidebrclose").classList.add("show-m");
        document.querySelector(".sidebaricon").classList.remove("show-n");
        document.querySelector(".sidebaricon").classList.add("show-m");
    };

    onHideSidebar = () => {
        document.querySelector(".page-body-wrapper").classList.add("sidebar-close");
        document.querySelector(".sidebaricon").classList.remove("show-n");
        document.querySelector(".sidebaricon").classList.add("show-m");
        document.querySelector(".siconbg").classList.remove("show-m");
        document.querySelector(".siconbg").classList.add("show-n");
        document.querySelector(".sidemenu").classList.remove("l20n");
        document.querySelector(".sidemenu").classList.add("whgb");
        document.querySelector(".sidebrclose").classList.remove("show-n");
        document.querySelector(".sidebrclose").classList.add("show-m");
    };

    render() {
        const { filteredMenu, searchQuery } = this.state;

        // Conditional CSS class based on "is_enmovil_transporter"
        const isEnmovilTransporter = localStorage.getItem("is_enmovil_transporter") == 1;
        const sideMenuCls = isEnmovilTransporter ? "sideMenuCls" : "";
        const sideTitlecls = isEnmovilTransporter ? "sideTitlecls" : "";
        const sideHeadercls = isEnmovilTransporter ? "sideHeadercls" : "";

        return (
            <div
                className={`page-sidebar custom-scrollbar page-sidebar-open ${sideMenuCls}`}
                onMouseEnter={this.props.openSidebar}
                onMouseLeave={this.props.closeSidebar}>
                <ul className="sidebar-menu">
                    <div style={{ position: "relative", marginBottom: "20px" }}>
                        <input
                            style={{
                                borderRadius: "0px",
                                fontSize: "12px",
                                padding: "8px 35px 8px 8px",
                                width: "230px",
                                outline: "0",
                                margin: "30px 0px 0px 0px",
                                border: "0",
                                borderBottom: "2px solid rgb(219 219 219)",
                            }}
                            type="text"
                            placeholder="Search menu..."
                            value={searchQuery}
                            onChange={this.onSearchChange}
                        />
                        {searchQuery && (
                            <i
                                className="fa fa-times"
                                style={{
                                    position: "absolute",
                                    right: "40px",
                                    top: "75%",
                                    transform: "translateY(-50%)",
                                    color: "#9b9191",
                                    cursor: "pointer",
                                }}
                                onClick={this.clearSearchAndCloseSidebar}
                            ></i>
                        )}
                    </div>

                    {filteredMenu && filteredMenu.map((menuItem, i) => (
                        <li className={`${menuItem.active ? "active" : ""}`} key={i}>
                            {/* {menuItem.is_group_header && (
                                <div className={`sidebar-title ${sideTitlecls}`}>
                                    {menuItem.group_heading}
                                </div>
                            )} */}

                            {!menuItem.is_link ? (
                                <a
                                    className={`sidebar-header ${sideHeadercls}`}
                                    href="javascript:void(0)"
                                    onClick={() => this.setNavActive(menuItem)}>
                                    <i className={`${menuItem.icon}`}></i>
                                    <span>{this.highlightSearchText(menuItem.name)}</span>
                                    {menuItem.children && (
                                        <i className="fa fa-angle-right pull-right"></i>
                                    )}
                                </a>
                            ) : (
                                <Link
                                    to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                                    className={`sidebar-header ${menuItem.active ? "active" : ""} ${sideHeadercls}`}
                                    onClick={() => this.setNavActive(menuItem, true)}
                                >
                                    <i className={`${menuItem.icon}`}></i>
                                    <span>{this.highlightSearchText(menuItem.name)}</span>
                                    {menuItem.children && (
                                        <i className="fa fa-angle-right pull-right"></i>
                                    )}
                                </Link>
                            )}
                            {menuItem.children && (
                                <ul className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}>
                                    {menuItem.children.map((child, index) => (
                                        <li
                                            key={index}
                                            className={`${child.active ? "active" : ""}`}
                                        >
                                            {!child.is_link ? (
                                                <a
                                                    href="javascript:void(0)"
                                                    onClick={() => this.setNavActive(child)}
                                                    style={{ paddingLeft: "12px" }}
                                                >
                                                    {menuItem.children && (
                                                        <i className="fa fa-angle-right pull-right"></i>
                                                    )}
                                                    {child.name}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={`${process.env.PUBLIC_URL}${child.path}`}
                                                    className={`${child.active ? "active" : ""}`}
                                                    onClick={() => this.setNavActive(child, true)}
                                                    style={{ paddingLeft: "12px" }}
                                                >
                                                    {child.name}
                                                </Link>
                                            )}

                                            {child.children && (
                                                <ul className={`sidebar-submenu ${child.active ? "menu-open" : ""}`}>
                                                    {child.children.map((subChild, subIndex) => (
                                                        <li
                                                            key={subIndex}
                                                            className={`${subChild.active ? "active" : ""}`}
                                                        >
                                                            {!subChild.is_link ? (
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={() => this.setNavActive(subChild)}
                                                                >
                                                                    {subChild.name}
                                                                </a>
                                                            ) : (
                                                                <Link
                                                                    to={`${process.env.PUBLIC_URL}${subChild.path}`}
                                                                    className={`${subChild.active ? "active" : ""}`}
                                                                    onClick={() => this.setNavActive(subChild, true)}
                                                                >
                                                                    {subChild.name}
                                                                </Link>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}

                </ul>
                <a
                    href="javascript:void(0)"
                    className="sidebar-blueicon"
                    onClick={this.onCloseSidebar.bind(this)}>
                    <span
                        id="ssinnerOpen"
                        className="show-m"
                        onClick={this.onCloseSidebar.bind(this)}
                    ></span>
                    <img
                        src={require("../../../assets/icons/SIDE-NAV.png")}
                        className="sidebaropen-icon"
                        onClick={this.onCloseSidebar.bind(this)}
                        alt="Open Sidebar"
                    />
                </a>
            </div>
        );
    }
}

// Wrap Sidebar2 with your custom withRouter to access router props
export default withRouter(Sidebar2);
